<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const route = useRoute()
const { t } = useI18n()

const items = computed(() => [
  {
    route: '/user/settings/profile',
    label: t('router.pages.user-settings-profile'),
    icon: 'i-lucide-user',
  },
  {
    route: '/user/settings/preferences',
    label: t('router.pages.user-settings-preferences'),
    icon: 'i-lucide-chart-line',
  },
  // {
  //   route: '/user/settings/apitokens',
  //   label: t('router.pages.user-settings-apitokens'),
  //   icon: 'i-lucide-key',
  //   requireUserType: ['employee', 'partner'],
  // },
])

const activeTab = computed(() => route.path)

definePage({
  redirect: '/user/settings/profile',
  alias: ['/user'],
  meta: {
    requiresAuth: true,
  },
})
</script>

<template>
  <div class="card">
    <AppTabs :value="activeTab" class="mb-2">
      <AppTabList>
        <AppTab v-for="tab in items" :key="tab.label" :value="tab.route" :to="tab.route">
          <UIcon :name="tab.icon" />
          <span>{{ tab.label }}</span>
        </AppTab>
      </AppTabList>
    </AppTabs>
    <router-view />
  </div>
</template>
